"use client";

import { c as _c } from "react/compiler-runtime";
import { NodeViewWrapper } from "@tiptap/react";
import DOMPurify from "dompurify";
import { useMemo, useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import { Button } from "@/components/ui";
interface QuoteAttrs {
  header: string;
  bodyHtml: string;
}
interface Props {
  attrs: QuoteAttrs;
  updateAttrs: (attrs: Partial<QuoteAttrs>) => void;
  selected: boolean;
}
export function QuoteTiptapView(t0) {
  const $ = _c(16);
  const {
    attrs
  } = t0;
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[0] !== attrs.bodyHtml) {
    t1 = attrs.bodyHtml ? DOMPurify.sanitize(attrs.bodyHtml) : "";
    $[0] = attrs.bodyHtml;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sanitizedHtml = t1;
  if (!attrs.bodyHtml) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <NodeViewWrapper data-block-type="emailQuote" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== expanded) {
    t2 = () => setExpanded(!expanded);
    $[3] = expanded;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = expanded ? "Hide original message" : "Show original message";
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HiDotsHorizontal className="py-0" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <div className="flex items-center gap-1"><Button type="button" onClick={t2} variant="ghost" size="sm" tooltip={t3} className="my-1 md:!py-0" icon={t4} /></div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== attrs.header || $[10] !== expanded || $[11] !== sanitizedHtml) {
    t6 = expanded && <div className="pl-3 border-l-2 border-border"><div className="text-caption text-foreground-secondary mb-1 whitespace-pre-line">{attrs.header}</div><div className="text-body text-foreground-secondary" dangerouslySetInnerHTML={{
        __html: sanitizedHtml
      }} /></div>;
    $[9] = attrs.header;
    $[10] = expanded;
    $[11] = sanitizedHtml;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <NodeViewWrapper data-block-type="emailQuote" contentEditable={false}>{t5}{t6}</NodeViewWrapper>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}